import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Products from "./assets/Products";
import YmHatBrwnGif from "./assets/ym-hat-brn/ym-hat-brn-gif.mp4";
import { theme } from "./assets/theme";
import { FaArrowLeft } from "react-icons/fa";
import YMBlack from "./assets/YMLogo";
import Nav2 from "./Nav2";

const spacing = 4;

const Store = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  return (
    <div id="Store" className={`h-screen w-screen bg-[${theme.main}]`}>
      {/* <nav className={`flex w-full items-center justify-between px-5 py-0`}>
        <div
          onClick={() => {
            navigate("/");
          }}
          className={`rounded-full p-2.5 hover:bg-white`}
        >
          <FaArrowLeft />
        </div>
        <div className="min-w-1/4 flex w-1/4 max-w-[150px] shrink items-center justify-center ">
          <YMBlack fill={"black"} />
        </div>
        <div
          className={`invisible w-[40px] rounded-full p-2.5 hover:bg-white`}
        ></div>
      </nav> */}
      <Nav2 />
      <div
        className={`py-4 px-${spacing} grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-${spacing}`}
      >
        {Products.map(({ image, title, price, id }, i) => (
          <div
            className="flex cursor-pointer flex-col"
            key={`item-${i}`}
            onClick={(e) => {
              e.preventDefault();
              navigate(`/store/item/${id}`, { image, title, price, id });
            }}
            // onSelect={(e) => {
            //   e.preventDefault();
            // }}
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onTouchStartCapture={() => setHovered(true)}
            onBlur={() => setHovered(false)}
          >
            <div>
              {hovered ? (
                <video
                  id="product-video"
                  alt="product"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  onSelect={(e) => {
                    e.preventDefault();
                  }}
                  className="aspect-square h-full w-full bg-transparent object-contain"
                  autoPlay
                  loop
                  muted
                  controls={false}
                  poster={image}
                  // src={`https://picsum.photos/id/63/800/800`}
                  src={YmHatBrwnGif}
                  type="video/mp4"
                >
                  <img
                    id="product-image"
                    alt="product"
                    className="aspect-square h-full w-full bg-transparent object-contain "
                    src={
                      image ||
                      // `https://picsum.photos/id/${item.id}/500/800`
                      `https://picsum.photos/id/63/800/800`
                    }
                  />
                </video>
              ) : (
                <img
                  id="product-image"
                  alt="product"
                  className="aspect-square h-full w-full bg-transparent object-contain "
                  src={
                    image ||
                    // `https://picsum.photos/id/${item.id}/500/800`
                    `https://picsum.photos/id/63/800/800`
                  }
                />
              )}
            </div>
            <div
              style={{
                background: `${hovered ? theme.secondary : theme.accent}`,
                color: `${hovered ? theme.accent : theme.secondary}`,
                transition: "color 0.3s, background 0.3s",
              }}
              className={`flex w-full flex-col p-1 text-center hover:bg-[${theme.accent}]  text-black`}
            >
              <div className="flex w-full items-center justify-center text-[30px] md:text-[40px]">
                {title}
              </div>
              <div className="flex w-full items-center justify-center text-[30px] md:text-[40px]">
                ${price}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Store;
